import api from './api';

const authService = {
  // Login
  login: async (username, password) => {
    try {
      const response = await api.post('/auth/login', { username, password });
      
      if (response.success && response.data.token) {
        // Guardar token y datos del usuario
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data));
      }
      
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Registro
  registro: async (userData) => {
    try {
      const response = await api.post('/auth/registro', userData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Logout
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/';
  },

  // Obtener usuario actual
  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  // Verificar si está autenticado
  isAuthenticated: () => {
    const token = localStorage.getItem('token');
    return !!token;
  },

  // Obtener perfil
  getPerfil: async () => {
    try {
      const response = await api.get('/auth/perfil');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Cambiar contraseña
  cambiarPassword: async (passwordActual, passwordNueva) => {
    try {
      const response = await api.put('/auth/cambiar-password', {
        passwordActual,
        passwordNueva
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default authService;